import { Modal, Form, Input, Select } from 'procredit-bank-design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

const { Option } = Select;


const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
};
const TransferModal = (props: any) => {
    const { transfer, modalVisible, setModalVisible, addTransfer, resetTransfer, columns } = props;

    const handleCancel = (e: any) => {
        setModalVisible(false);
        form.resetFields();
        resetTransfer();
    };

    const validateMessages = {
        required: '${label} is required!',
        string: {
            max: '${label} cannot contain more than ${max} characters',
            len: '${label} must contain exactly ${len} characters'
        },
        number: {
            range: '${label} must be between ${min} and ${max}',
        },
        pattern: {
            mismatch: '${label} cannot contain commas'
        }
    };
    const [form] = Form.useForm();
    React.useEffect(() => {
        form.setFields([{ name: 'user', value: transfer }]);
    }, [transfer, form]);

    const handleOk = (e: any) => {
        form.validateFields()
            .then((values: any) => {
                form.resetFields();
                setModalVisible(false)
                addTransfer(transfer.key, values.user);
            })
            .catch((info: any) => {
                console.log('Validate Failed:', info);
            });

    };
    const { t } = useTranslation();

    const [validationMode, setValidationMode] = React.useState<Array<any>>([])

     if (Array.isArray(columns) && columns.length > 0 && validationMode.length === 0) {
         setValidationMode(columns.map((c: any) => ({ key: c.key, value: 'onBlur' })));
    }

    const changeValidationMode = (fieldName: any) => {
        setValidationMode(validationMode.map(v => v.key === fieldName ? { key: v.key, value: 'onChange' } : v));
    };

    const substituteReservedCharactersOnPaste = (event: any, key: string) => {
        let {user} = form.getFieldsValue();

        const start = event.target.selectionStart;
        const end = event.target.selectionEnd;
        
        const before = user[key] ? user[key].slice(0, start) : '';
        const after = user[key] ? user[key].slice(end) : '';
        user[key] = before + event.clipboardData.getData('Text').replace(/\t/g, ' ') + after;
        form.setFieldsValue({user});
        event.target.setSelectionRange(1,1);
        event.preventDefault();
    }

    return (
        <Modal
            title={t('addTransfer')}
            visible={modalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            getContainer={false}
            okText={t('ok')}
            cancelText={t('cancel')}
        >
            <div>
                <Form {...layout} name="nest-messages" validateMessages={validateMessages} form={form}>
                    {validationMode.length > 0 && columns.map((c: any) => {
                        if (!c.options) {
                            return (
                                <Form.Item
                                    onPaste={(e: any) => substituteReservedCharactersOnPaste(e, c.key)}
                                    onBlur={() => changeValidationMode(c.key)}
                                    validateTrigger={validationMode.find((v: any) => v.key === c.key)?.value}
                                    className={'two-rows-label'}
                                    key={c.key} label={t(c.key)}
                                    name={['user', c.key]}
                                    rules={c.rules.some((el: any) => Object.keys(el).includes('pattern')) ? c.rules : [...c.rules, { pattern: '^[^\n,]*$' }]}>
                                    <Input />
                                </Form.Item>)
                        } else {
                            return (
                                <Form.Item className={'two-rows-label'} key={c.key} label={t(c.key)} name={['user', c.key]} rules={[...c.rules, { pattern: '^[^\n,]*$' }]}>
                                    <Select onBlur={() => changeValidationMode(c.key)}>
                                        {c.options.map((o: any) => {
                                            return (
                                                <Option key={o} value={o}>
                                                    {o}
                                                </Option>
                                            )
                                        })}
                                    </Select>
                                </Form.Item>)
                        }
                    })}
                </Form>
            </div>
        </Modal>
    )
};
export default TransferModal;